export default __webpack_public_path__ + "static/media/report.6e351180.svg";